import { CONTACT_PORTRAIT_SRC, bookingUrl, phoneTel } from '../data/ai-agency-content.js'
import { useAiAgencyContent } from '../hooks/i18n/usePageContent.js'
import {
  FixerCard,
  FixerCtaRow,
  FixerKicker,
  FixerSection,
  FixerSectionIntro,
  FixerSignalDivider,
} from './fixer-ui.js'
import { FbcDot } from './future-chat/FbcGrammar.js'

interface AiAgencyContactSectionProps {
  year: number
  onStartChat?: (() => void) | undefined
}

export function AiAgencyContactSection({ year, onStartChat }: AiAgencyContactSectionProps) {
  const c = useAiAgencyContent()
  return (
    <FixerSection id="kontakt">
      <div className="fixer-stack-xl">
        <div className="fixer-contact-band">
          <div className="fixer-contact-portrait-wrap">
            <img
              src={CONTACT_PORTRAIT_SRC}
              alt={c.contact.portraitAlt}
              className="fixer-contact-portrait"
              width={320}
              height={400}
              loading="lazy"
            />
          </div>
          <div className="fixer-contact-band-copy fixer-stack-lg">
            <FixerSectionIntro
              channel="transmit"
              kicker={c.contact.number}
              title={c.contact.title}
              copy={c.contact.copy}
              titleId="agency-contact-heading"
            />
            <p className="fixer-subheading">Farzad Bayat — {c.contact.roleLine}</p>
            <p className="fixer-body-sm">{c.contact.locationLine}</p>
            <FixerCtaRow>
              <button type="button" onClick={onStartChat} className="fixer-btn-primary w-full sm:w-auto">
                {c.contact.chatCta}
              </button>
              <a href={phoneTel} className="fixer-btn-secondary w-full sm:w-auto">
                {c.contact.callLabel}
              </a>
              <a
                href={bookingUrl}
                target="_blank"
                rel="noreferrer"
                className="fixer-btn-secondary w-full sm:w-auto"
              >
                {c.contact.bookCta}
              </a>
            </FixerCtaRow>
          </div>
        </div>

        <div className="fixer-card-grid-5">
          {c.contactLinks.map(link => (
            <FixerCard key={link.label} interactive>
              <a
                href={link.href}
                target={link.href.startsWith('http') ? '_blank' : undefined}
                rel={link.href.startsWith('http') ? 'noreferrer' : undefined}
                className="flex flex-col gap-2 no-underline"
              >
                <FixerKicker channel="signal" active={false}>{link.label}</FixerKicker>
                <span className="fixer-subheading text-[var(--fc-accent)]">{link.value}</span>
              </a>
            </FixerCard>
          ))}
        </div>

        <p className="fixer-body-sm text-center text-[var(--fc-text-muted)]">{c.contact.footnote}</p>

        <footer className="fixer-page-footer">
          <FixerSignalDivider className="mb-6" />
          <div className="fixer-footer-row">
            <div className="flex items-center gap-2">
              <FbcDot state="signal" />
              <span>© {year} Farzad Bayat</span>
            </div>
            <nav className="fixer-footer-nav" aria-label="Site links">
              {c.footerLinks.map(link => (
                <a
                  key={link.href}
                  href={link.href}
                  className="fixer-footer-link"
                  target={link.href.startsWith('http') ? '_blank' : undefined}
                  rel={link.href.startsWith('http') ? 'noreferrer' : undefined}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
          <div className="mt-3">{c.footerTagline}</div>
        </footer>
      </div>
    </FixerSection>
  )
}
